import Vue from 'vue'
import Router from 'vue-router'

const Home = () => import(/* webpackChunkName: "home" */ './components/Home' );
const Privacy = () => import(/* webpackChunkName: "privacy" */ './components/Privacy' );
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ './components/Dashboard' );
const Feedback = () => import(/* webpackChunkName: "feedback" */ "./components/Feedback" );
const Login = () => import(/* webpackChunkName: "user" */ './components/Login' );
const ForgotPassword = () => import(/* webpackChunkName: "user" */'./components/ForgotPassword' );
const SignUp = () => import(/* webpackChunkName: "user" */ './components/SignUp' );
const ResetPassword = () => import(/* webpackChunkName: "user" */ './components/ResetPassword' );
const TermOfUse = () => import(/* webpackChunkName: "term" */ './components/TermOfUse' );
const PageNotFound = () => import(/* webpackChunkName: "error" */ './components/PageNotFound' );
const MyAccount = () => import(/* webpackChunkName: "user" */ './components/MyAccount' );
const NotificationSettings = () => import(/* webpackChunkName: "user" */ "./components/NotificationSettings" );
const Search = () => import(/* webpackChunkName: "report" */ "./components/Search" );
const ReportDetail = () => import(/* webpackChunkName: "report" */ './components/ReportDetail' );
const MarketTrendDetail = () => import(/* webpackChunkName: "report" */ "@/components/MarketTrendDetail" );
const RecentSoldDetail = () => import(/* webpackChunkName: "report" */ "@/components/RecentSoldDetail" );
const InnerSizeDetail = () => import(/* webpackChunkName: "report" */ "@/components/InnerSizeDetail" );
const BuildLandSizeDetail = () => import(/* webpackChunkName: "report" */ "@/components/BuildLandSizeDetail" );

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                title: 'BC Homes Value Estimator - The best online home value estimation tool for Victoria, Vancouver properties.',
                requiresLogin: false,
            },
            props: {
                default: true,
                currentRoute: 'home'
            }
        },
        {
            path: '/index.html',
            name: 'homeIndex',
            component: Home,
            meta: {
                title: 'BC Homes Value Estimator - The best online home value estimation tool for Victoria, Vancouver properties.',
                requiresLogin: false,
            },
            props: {
                default: true,
                currentRoute: 'home'
            }
        },
        {
            path: '/search',
            name: 'search',
            component: Search,
            meta: {
                title: "What's My Home Worth? - Greater Victoria, Vancouver BC Home Values",
                requiresLogin: false,
            },
            props: {
                default: true,
                currentRoute: 'search'
            }
        },
        {
            path: '/privacy-policy',
            name: 'privacy',
            component: Privacy,
            meta: {
                title: 'Privacy Policy',
                requiresLogin: false,
            }
        },
        {
            path: '/term-of-use',
            name: 'termOfUse',
            component: TermOfUse,
            meta: {
                title: 'Term of Use',
                requiresLogin: false,
            }
        },
        {
            path: '/users/login',
            name: 'login',
            component: Login,
            meta: {
                title: 'Login',
                guestOnly: true,
            },
            props: true,
        },
        {
            path: '/users/sign-up',
            name: 'signup',
            component: SignUp,
            meta: {
                title: 'Sign Up',
                guestOnly: true,
            },
            props: true
        },
        {
            path: '/users/notification-settings',
            name: 'notificationSettings',
            component: NotificationSettings,
            meta: {
                title: 'Notification Settings',
            },
            props: (route) => ({ _mnsc: route.query._mnsc })
        },
        {
            path: '/users/forgot-password',
            name: 'forgotPassword',
            component: ForgotPassword,
            meta: {
                title: 'Forgot Password',
                guestOnly: true,
            }
        },
        {
            path: '/users/password-reset/:token',
            name: 'resetPassword',
            component: ResetPassword,
            meta: {
                title: 'Reset Password',
            },
            props: true
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            meta: {
                title: 'Dashboard',
                requiresLogin: true,
            },
            props: {
                default: true,
                currentRoute: 'dashboard'
            }
        },
        {
            path: '/my-account',
            name: 'myAccount',
            component: MyAccount,
            meta: {
                title: 'My Account',
                requiresLogin: true,
            },
            props: {
                default: true,
                currentRoute: 'myAccount'
            }
        },
        {
            path: '/feedback',
            name: 'feedback',
            component: Feedback,
            meta: {
                title: 'Feedback',
                requiresLogin: false,
            },
            props: {
                default: true,
                currentRoute: 'feedback'
            }
        },
        {
            path: '/:pageID/market-trends-analysis',
            name: 'marketTrendsDetails',
            component: MarketTrendDetail,
            meta: {
                title: 'Market Trends Analysis',
                requiresLogin: true,
            },
            props: true
        },
        {
            path: '/:pageID/recent-sold-analysis',
            name: 'recentSoldDetail',
            component: RecentSoldDetail,
            meta: {
                title: 'Recent Sold Analysis',
                requiresLogin: true,
            },
            props: true
        },
        {
            path: '/:pageID/interior-size-analysis',
            name: 'innerSizeDetail',
            component: InnerSizeDetail,
            meta: {
                title: 'Interior Size Analysis',
                requiresLogin: true,
            },
            props: true
        },
        {
            path: '/:pageID/building-land-value-analysis',
            name: 'buildLandSizeDetail',
            component: BuildLandSizeDetail,
            meta: {
                title: 'Land + Building Value Analysis',
                requiresLogin: true,
            },
            props: true
        },
        {
            path: '/:pageID/:slug?',
            name: 'reportDetail',
            component: ReportDetail,
            meta: {
                title: 'Report Detail',
                requiresLogin: false,
            },
            props: true
        },
        {
            path: '*',
            name: 'pageNotFound',
            component: PageNotFound
        }
    ],
    scrollBehavior() {
        return {x: 0, y: 0}
    }
})
